import styled from "styled-components";

const FlipDocumentAnimationRoot = styled.div`
  width: 100px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;

  .flip {
    width: 70%;
    height: 80%;
    position: relative;
    align-self: center;
    perspective: 1000px;
  }

  .flip svg,
  .flip img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .flip .front,
  .flip .back {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    transition: all 0.6s ease-out;
  }

  .flip .front,
  .flip .back {
    animation-fill-mode: forwards;
  }

  .flip .front {
    z-index: 2;
    animation: flip-front 3s 1s infinite;
  }

  .flip .back {
    transform: rotateY(180deg);
    animation: flip-back 3s 1s infinite;
  }

  @keyframes flip-front {
    0% {
      transform: rotateY(0deg);
      opacity: 1;
    }
    75% {
      transform: rotateY(-180deg);
    }

    100% {
      transform: rotateY(-180deg);
    }
  }

  @keyframes flip-back {
    0% {
      transform: rotateY(180deg);
      opacity: 1;
    }
    75% {
      transform: rotateY(0deg);
      opacity: 1;
    }
    100% {
      transform: rotateY(0);
      opacity: 0;
    }
  }
`;

export default FlipDocumentAnimationRoot;
